module.exports = __webpack_public_path__ + "img/ic-tf.ff23e9a8.svg";